import { Drawer } from 'components/Drawer'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'
import { CommentInput } from './CommentInput'
import { useLayout } from 'stores/LayoutStore'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'

interface Props extends DrawerProps {
  view?: EditorView
}

export const CreateCommentDrawer = observer(({ view, ...props }: Props) => {
  const drawersStore = useRootStore().drawersStore
  const layout = useLayout()
  const layoutViewport = layout.viewport

  if (!view) return null

  return (
    <Drawer.Root onOpen={() => view.dispatch(view.state.tr.scrollIntoView())} onClose={() => view?.focus()} {...props}>
      <Drawer.Portal>
        <Drawer.Content layoutViewport={layoutViewport} heightDynamic>
          <Drawer.InnerContent withShadow>
            <Drawer.Container>
              <CommentInput view={view} onSuccess={() => drawersStore.closeDrawer()} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
